
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function ErrorLogIndex() {
  return (
    <NonFSIndex
      data_type="error_log"
    />
  );
}
